const initialState = {
    data: null,

    errors: {},
    errorModal: false,
}

export default function ica(state = initialState, action) {
    switch (action.type) {
        case 'SIGN_OUT':
            return initialState

        case 'LOAD_ICA_SUCCESS':
        case 'SUBMIT_ICA_SUCCESS':
            return {
                ...state,
                data: action.data,
                errors: {},
            }

        case 'SUBMIT_ICA_ERROR':
            if (action.errors && action.errors.message) {
                // eslint-disable-next-line no-alert
                alert(action.errors.message)
            }

            return {
                ...state,
                data: null,
                errors: action.errors || {},
                errorModal: Date.now(),
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/ica.js